import React, { useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { Paper } from '@mui/material';
import { selectAdmins } from '../../redux/slices/adminsSlice';
import { selectAuth } from '../../redux/slices/authSlice';
import { selectCities } from '../../redux/slices/citiesSlice';
import Title from '../../components/Title';
import MapMarkersSection from '../../components/sections/MapMarkersSection';

const defaultCenter = {
  lat: 48.9225224,
  lng: 24.7103188
};

const PREFIX = 'MapMarkersPage';

const classes = {
  title: `${PREFIX}-title`
};

const Root = styled('div')({
  [`& .${classes.title}`]: {
    marginBottom: 20
  }
});

const MapMarkersPage = () => {
  const theme = useTheme();
  const admins = useSelector(selectAdmins);
  const auth = useSelector(selectAuth);
  const cities = useSelector(selectCities);
  
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  const currentCityId = admins.currentCity ?? '';

  useEffect(() => {
    let nextMapCenter;

    if (auth.info?.type === 'superAdmin') {
      const city = cities.items.find(item => item._id === admins.currentCity);
      if (city?.lat && city.lon) {
        nextMapCenter = {
          lat: city.lat,
          lng: city.lon
        };
      }
    } else if (admins.info && admins.currentCity) {
      const city = admins.info.cities.find(
        item => item._id === admins.currentCity
      );
      if (city?.lat && city.lon) {
        nextMapCenter = {
          lat: city.lat,
          lng: city.lon
        };
      }
    }

    if (!nextMapCenter) {
      setMapCenter(defaultCenter);
    } else {
      setMapCenter(nextMapCenter);
    }
  }, [admins.currentCity, admins.info, auth.info, cities.items]);

  return (
    <Root>
      <Title className={classes.title}>Маркери на карті</Title>
      
      <Paper 
        sx={{ 
          border: theme.palette.mode === 'light' ? '2px solid #FFFFFF' : 'none', 
          borderRadius: 2,
          padding: '20px'
        }}
      >
        <MapMarkersSection mapCenter={mapCenter} currentCityId={currentCityId} />
      </Paper>
    </Root>
  );
};

export default MapMarkersPage;
